import React, { useState, useEffect } from 'react';
// import BackgroundImage from '../../images/framePhoto.png';
import { Progress } from 'reactstrap';
import { ImCogs } from 'react-icons/im';
import { usePortContext } from '../../../service/MessageChannelContext';

const LoaderWithImg = ({ image }) => {
  const backgroundImage = image;
  const [progress, setProgress] = useState(1);
  const { image: imageA, depthMap, keypointsData, boundingBoxData } = usePortContext();
  useEffect(() => {
    // Simulate progress increment every 20 milliseconds
    const interval = setInterval(() => {
      if (progress < 100) {
        setProgress(progress + 1);
      } else {
        clearInterval(interval); // Stop the interval when progress reaches 100
      }
    }, 50);

    return () => {
      clearInterval(interval); // Clean up the interval on unmounting
    };
  }, [progress]);

  useEffect(() => {}, [depthMap]);

  const loaderClasses = `loaderBg ${progress >= 100 ? 'opacityBg' : ''}`;

  return (
    <div className={loaderClasses}>
      <div className="backgroundOverlay" style={{ backgroundImage: `url(${backgroundImage})` }}></div>
      {progress < 99 && (
        <div className="progressbarContainer">
          <Progress color="danger" value={progress} />
          <h3 className={'default-text redtext font-weight-700 mt-4'}> Uploading... </h3>
        </div>
      )}
      {progress >= 100 && (
        <div className="progressBarCompleted">
          <ImCogs className={'redtext'} size={50} />
          <h3 className={'default-text redtext font-weight-700 mt-4'}> Analyzing your skin ... </h3>
        </div>
      )}
    </div>
  );
};

export default LoaderWithImg;
